import React from 'react';
import { useGetCmsArticlesQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { NewsRow } from './components/NewsRow';

type NewsListViewProps = {};

export const NewsListView: React.FC<NewsListViewProps> = () => {
  const languagesInfo = useLanguage();
  const t = languagesInfo[0];
  const locale = languagesInfo[2];
  const back = useBack();

  const { data: news } = useGetCmsArticlesQuery({ locale });

  return (
    <BaseLayout onBackClick={back} hasBack title={t('pageTitles.news')}>
      {news && news.map((n) => <NewsRow key={n.id} article={n} />)}
    </BaseLayout>
  );
};
